export default "__VITE_ASSET__CSuYtx09__"